import React from "react"
import PropTypes from "prop-types"
import { withStyles } from "@material-ui/core/styles"

import * as am4core from '@amcharts/amcharts4/core';
import { color } from '@amcharts/amcharts4/.internal/core/utils/Color';

import { XYChart3D } from '@amcharts/amcharts4/.internal/charts/types/XYChart3D';
// import { Legend } from '@amcharts/amcharts4/.internal/charts/Legend';
import { ConeSeries } from '@amcharts/amcharts4/.internal/charts/series/ConeSeries';
import { CategoryAxis } from '@amcharts/amcharts4/.internal/charts/axes/CategoryAxis';
import { ValueAxis } from '@amcharts/amcharts4/.internal/charts/axes/ValueAxis';
import { useTheme } from '@amcharts/amcharts4/.internal/core/utils/Instance';
import { LabelBullet } from '@amcharts/amcharts4/.internal/charts/elements/LabelBullet';

import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import {Legend} from "@amcharts/amcharts4/.internal/charts/Legend";
am4core.useTheme(am4themes_animated);

const COLORS = {
  'New': color('#1ABC9C'),
  'Closed': color('#FEBC77'),
  'In Progress': color('#D65DB1'),
  'On Hold': color('#2980B9'),
  'Cancelled': color('#F1C40F'),
  'default': color('#FF7043'),
  'severity 1': color("#27AE60"),
  'severity 2': color('#8DB7D7'),
  'severity 3': color("#8E44AD"),
  'severity 4': color("#FF8083"),
  'severity 5': color('#AD1457'),
};

class ColumnCylinder extends React.Component {
  static propTypes = {
    legend: false,
    gridItemProps: PropTypes.object,
    item: PropTypes.object,
    onClickFavourite: PropTypes.func,
    withFavourites: PropTypes.bool,
  };

  constructor(props) {
    super(props)
  }

  componentDidMount() {
    this.chart = am4core.create("linder", XYChart3D);
    this.chart.angle = 35;

    if (this.props.legend) {
      this.chart.legend = new Legend();
      this.chart.legend.position = 'right';
      this.chart.legend.align = 'center';
      this.chart.legend.paddingLeft = 24;
      this.chart.legend.itemContainers.template.clickable = true;
      this.chart.legend.itemContainers.template.focusable = false;
      this.chart.legend.labels.template.fill = color('#CEDBDC');
      this.chart.legend.labels.template.fontSize = 14;
      this.chart.legend.labels.template.fontWeight = 'bold';
      this.chart.legend.useDefaultMarker = true;
      this.marker = this.chart.legend.markers.template.children.getIndex(0);
      this.marker.cornerRadius(12, 12, 12, 12);
      this.marker.width = 14;
      this.marker.height = 14;
      this.marker.dy = 4;
      this.marker.dx = -5;
    }

    this.categoryAxis = this.chart.xAxes.push(new CategoryAxis());
    this.categoryAxis.dataFields.category = "key";
    this.categoryAxis.renderer.grid.template.location = 0;
    this.categoryAxis.renderer.minGridDistance = 20;
    this.categoryAxis.renderer.inside = true;
    this.categoryAxis.renderer.grid.template.disabled = true;

    let labelTemplate = this.categoryAxis.renderer.labels.template;
    labelTemplate.rotation = -90;
    labelTemplate.fontSize = 14;
    labelTemplate.fontWeight = 'bold';
    labelTemplate.fill = color('#CEDBDC');
    labelTemplate.horizontalCenter = "left";
    labelTemplate.verticalCenter = "middle";
    labelTemplate.dy = 10; // moves it a bit down;
    labelTemplate.inside = false; // this is done to avoid settings which are not suitable when label is rotated

    this.valueAxis = this.chart.yAxes.push(new ValueAxis());
    this.valueAxis.renderer.grid.template.disabled = true;
    this.valueAxis.renderer.labels.template.fill = color('#A09E99');
    this.valueAxis.extraMax = 0.2;


    this.createSeries();
    this.updateChartsData();

  }

  componentWillUnmount() {
    if (this.chart) {
      this.chart.dispose();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.datasets !== prevProps.datasets) {
      this.updateChartsData();
    }
  }

  createSeries = () => {
    this.series = this.chart.series.push(new ConeSeries());
    this.series.dataFields.valueY = "value";
    this.series.dataFields.categoryX = "key";
    this.series.dy = -20;
    this.series.legendSettings.valueText = '{valueY}';


    let valueLabel = this.series.bullets.push(new LabelBullet());
    valueLabel.label.text = "{valueY}";
    valueLabel.label.fontSize = 20;
    valueLabel.label.fontWeight = 'bold';
    valueLabel.label.fill = am4core.color("#CEDBDC");
    valueLabel.dy = -55;

    const columnTemplate = this.series.columns.template;
    columnTemplate.adapter.add("fill", function(fill, target) {
      if (!target.dataItem) {
        return fill;
      }
      return COLORS[target.dataItem.dataContext['key']];
    })
    columnTemplate.adapter.add("stroke", function(stroke, target) {
      return COLORS[target.dataItem.dataContext['key']];
    })
  }

  updateChartsData = () => {
    const { datasets } = this.props;

    if (!datasets) {
      return null;
    }

    const normalizeText = {
      new: 'New',
      closed: "Closed",
      inProgress: "In Progress",
      onHold: "On Hold",
      resolved: "Resolved",
      cancelled: "Cancelled",
      severity1: "severity 1",
      severity2: "severity 2",
      severity3: "severity 3",
      severity4: "severity 4",
      severity5: "severity 5"
    }

    let newDataset = Object.entries(datasets).map(([key, value]) => {
      if (!value) delete datasets[key]

      return {
        key: normalizeText[key],
        color: COLORS[key],
        value: +value,
        value2: value * 2
      }
    })

    this.chart.data = newDataset.filter(item => item.value);


    if (this.props.legend) {
      this.chart.legend.data = newDataset.map((type) => ({
        name: type.key,
        fill: COLORS[type.key]
      }))
    }

  }

  render() {
    return (
      <div>
        <div id="linder" style={{ position: 'relative', width: '100%', height: "500px" }}></div>
      </div>
    )
  }
}

ColumnCylinder.propTypes = {
  datasets: PropTypes.array
}

ColumnCylinder.defaultProps = {
  legend: false,
  dy: -20
};

export default ColumnCylinder
